import type { Translation } from "~/types/i18n";

export const en: Translation = {
  nav: {
    top: "TOP",
    pv: "PV",
    introduction: "INTRODUCTION",
    character: "CHARACTER",
    news: "NEWS",
    goods: "GOODS",
    onair: "ON AIR",
    special: "SPECIAL",
  },
  hero: {
    comingSoon: "BROADCASTING INFO COMING SOON",
    scrollDown: "SCROLL",
  },
  pv: {
    title: "PV",
    subtitle: "Promotional Video",
  },
  synopsis: {
    title: "STORY",
    subtitle: "Synopsis",
  },
  characters: {
    title: "CHARACTER",
    subtitle: "Character Introduction",
    cv: "CV",
  },
  news: {
    title: "NEWS",
    subtitle: "Latest Updates",
    new: "NEW",
    noNews: "No news available",
  },
  md: {
    title: "MD",
    subtitle: "Official Goods",
    visitStore: "Visit Store",
    goBack: "Go Back",
    viewDetail: "View Details",
    buyNow: "Buy Now",
  },
  onair: {
    title: "ON AIR",
    subtitle: "Broadcast Information",
  },
  special: {
    title: "SPECIAL",
    subtitle: "Special Contents",
  },
  footer: {
    policy: "Privacy Policy",
    originals: "Laftel Originals",
    contact: "Contact Us",
    share: "Share on X",
    copyright: "© 2025 Laftel Inc. All Rights Reserved.",
  },
  cta: {
    comingSoon: "Coming Soon",
  },
  home: {
    heroSubtitle: "Original anime, crafted by Laftel",
    aboutTitle: "Empowering Fans Everywhere",
    aboutDescription:
      "We, Laftel, expand the diversity of the animation ecosystem\nby integrating production, investment, merchandise,\nand offline ventures based on subculture IPs.\nImmerse yourself in a new world of content\nthrough the captivating stories discovered by Laftel Originals.",
    worksTitle: "Original Works",
    comingSoon: "COMING SOON",
    navAbout: "ABOUT",
    navWorks: "WORKS",
    watchOnYoutube: "Watch on YouTube",
  },
};
